export const API_EXTERNAL_ENDPOINT = 'cottage-deals/deal/:deal_id'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottage-deals/deal'
